<div class="popup-address">
  <h2 i18n="@@ChooseAddress">Введите адрес доставки</h2>
  <form aria-labelledby="title">
    <div class="form-content">
      <div class="form-control-group">
        <app-dadata (selected)="onSelect($event)"
                    i18n-placeholder="@@DeliveryAddress"
                    placeholder="Адрес доставки">
        </app-dadata>
      </div>
    </div>
    <button nbButton
            status="primary"
            type="button"
            [nbSpinner]="submitted"
            nbSpinnerStatus="control"
            i18n="@@Save"
            (click)="onSubmit()"
            [disabled]="!selected() || submitted">
      Сохранить
    </button>
  </form>
</div>
